import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-custom-select',
  template: `
    <div class="custom-select" [class]="{ 'open': isOpen }" (click)="toggleDropdown()">
      <div class="selected-option">{{ selectedOption.label || '...' }}</div>
      <ul *ngIf="isOpen">
        <li *ngFor="let option of options" (click)="selectOption(option)">
          {{ option.valor === 0 ? 'Grátis' : 'R$' + option.valor }} - {{ option.label }} - {{ option.labelPrazo }}
        </li>
      </ul>
    </div>
  `,
  styles: [`
    .custom-select {
      position: relative;
      display: inline-block;
      cursor: pointer;
      width: 100%;
    }

    .selected-option {
      padding: 8px;
      border: 1px solid #ccc;
      border-radius: 4px;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      border: 1px solid #ccc;
      border-radius: 4px;
      background-color: #fff;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      display: none;
    }

    ul li {
      padding: 8px;
      cursor: pointer;
    }

    ul li:hover {
      background-color: #f0f0f0;
    }

    .open ul {
      display: block;
    }
  `]
})
export class CustomSelectComponent {
  @Input() options: any[] = [];
  @Input() selectedOption: any;
  @Output() optionSelected = new EventEmitter<any>();

  isOpen: boolean = false;

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectOption(option: any) {
    this.selectedOption = option;
    this.optionSelected.emit(option);
    this.isOpen = false;
  }
}